<template>
	<div class="col-12 p-0 mb-3" v-if="total > 10">
		<div class="row d-flex justify-content-between px-0">
			<div class="col-sm-12 col-md-4">
				<div class="form-inline">
					<select
						class="form-control"
						v-model="pageSize"
						@change="currentPage = 1"
						style="width: auto"
					>
						<option value="10">10</option>
						<option value="50">50</option>
						<option value="100">100</option>
					</select>
					<div class="py-0 px-2">Por página</div>
				</div>
			</div>
			<div class="col-sm-12 col-md-2 py-0 text-center">
				{{ currentLengthResult }} de {{ total }} resultados
			</div>
			<div class="col-sm-12 col-md-auto" v-if="numPage > 1">
				<ul class="pagination">
					<li class="page-item">
						<a class="page-link" alt="Anterior " @click="prevPage">
							<i class="mdi mdi-chevron-left"></i>
						</a>
					</li>

					<li class="page-item">
						<a class="page-link" @click="currentPage = 1">1</a>
					</li>
					<li class="page-item" v-if="currentPage > 3 && numPage > 3">
						<a class="page-link">...</a>
					</li>

					<li
						:class="`page-item ${i + 1 == currentPage ? 'active' : ''}`"
						@click="pageCurrent(i + 1)"
						v-for="(page, i) in numDataPerPage"
						:key="i"
					>
						<a
							class="page-link"
							v-if="
								page > 1 && page > currentPage - 2 && page < currentPage + 2 && page < numPage
							"
						>
							{{ i + 1 }}
						</a>
					</li>

					<li
						class="page-item"
						v-if="numPage > numPage / 2 && numPage != currentPage && numPage > 3"
					>
						<a class="page-link">...</a>
					</li>
					<li class="page-item">
						<a class="page-link" @click="currentPage = numPage">
							{{ numPage }}
						</a>
					</li>
					<li class="page-item">
						<a class="page-link" alt="Próximo" @click="nextPage"
							><i class="mdi mdi-chevron-right"></i
						></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["total", "current"],
	data() {
		return {
			currentPage: this.current,
			currentLengthResult: 0,
			pageSize: 10,
			numPage: 0,
		};
	},
	watch: {
		currentPage(value) {
			if (isNaN(value)) {
				this.currentPage = 1;
			}
			this.$emit("update", value, this.pageSize);
		},
	},
	mounted() {
		this.getCalc();
	},
	updated() {
		this.getCalc();
	},
	computed: {
		numDataPerPage() {
			this.getResultPage();
			return this.calcNumeroPage();
		},
	},
	methods: {
		getCalc() {
			this.calcNumeroPage();
			this.getResultPage();
		},
		calcNumeroPage() {
			var num = this.total / this.pageSize;
			this.numPage = num < 0 ? this.total : Math.ceil(num);
			return this.numPage;
		},
		getResultPage() {
			this.currentPage = parseInt(this.currentPage);
			let start = (this.currentPage - 1) * this.pageSize;
			let end = this.currentPage * this.pageSize;
			let total = this.total;

			if (start == 0) {
				if (end > total) {
					this.currentLengthResult = total;
				} else {
					this.currentLengthResult = this.countInterval(start, end);
				}
			} else {
				if (end > total) {
					this.currentLengthResult = total;
				} else {
					this.currentLengthResult = parseInt(this.currentPage) * parseInt(this.pageSize);
				}
			}

			this.$emit("update", this.currentPage, this.pageSize);
		},
		nextPage() {
			if (this.currentPage * this.pageSize < this.total) this.currentPage++;
			this.getResultPage();
		},
		pageCurrent(i) {
			this.currentPage = i;
		},
		prevPage() {
			if (this.currentPage > 1) this.currentPage--;
			this.getResultPage();
		},
		countInterval(a, b) {
			var count = 0;
			while (a < b) {
				a++;
				count++;
			}
			return count;
		},
	},
};
</script>
<style lang="css">
.page-link {
	cursor: pointer !important;
}
</style>
